// src/pages/Marketplace/surge-pricing/DayOfWeekTable.tsx
import React from 'react';
import { BASE_PRICE_CENTS, DAY_LABELS, SURGE_DAY_OF_WEEK } from '@/pages/Marketplace/shared';

export default function DayOfWeekTable(): React.ReactElement {
  return (
    <div>
      <h2 className="text-sm font-semibold text-white mb-2">Day-of-week schedule</h2>
      <table className="w-full max-w-sm text-sm border border-gray-800 rounded-lg overflow-hidden">
        <tbody>
          {DAY_LABELS.map((label, idx) => (
            <tr key={label} className="border-t border-gray-800 first:border-t-0">
              <td className="px-3 py-1.5 text-gray-400">{label}</td>
              <td className="px-3 py-1.5 text-right">{SURGE_DAY_OF_WEEK[idx]}×</td>
              <td className="px-3 py-1.5 text-right text-gray-400">
                ${((BASE_PRICE_CENTS * SURGE_DAY_OF_WEEK[idx]) / 100).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-xs text-gray-500 mt-2">
        Day-of-week pricing is set globally in code and cannot be edited here. Contact engineering to change base multipliers.
      </p>
    </div>
  );
}
